import React from 'react';
import { IconCreditCard } from '@tabler/icons-react';

import { useTranslate } from '@src/core/hooks';
import { type PaymentOption } from '@src/domains/payments';

import { DisclaimerCard, DisclaimerIcon, DisclaimerText } from './styles';

type PaymentSoftDescriptorProps = {
  option: PaymentOption | undefined;
};

export const PaymentSoftDescriptor = (props: PaymentSoftDescriptorProps) => {
  const { option } = props;
  const { i18n } = useTranslate();
  const softDescriptor = option?.softDescriptor;

  if (!softDescriptor) {
    return null;
  }

  return (
    <DisclaimerCard data-testid='payment-soft-descriptor'>
      <DisclaimerIcon>
        <IconCreditCard size={24} aria-hidden />
      </DisclaimerIcon>
      <DisclaimerText>{`${i18n('checkout_method_softdescriptor')} ${softDescriptor}`}</DisclaimerText>
    </DisclaimerCard>
  );
};

export default PaymentSoftDescriptor;
